import angular from 'angular';

export const extSubmit = $timeout => ({
    link($scope, $el, $attr) {
        $scope.$on('makeSubmit', (event, data) => {
            if (data.formName === $attr.name) {
                $timeout(() => {
                    $el.triggerHandler('submit');
                }, 0, false);
            }
        });
    },
});

angular
    .module('TALENYA-FE')
    .directive('extSubmit', extSubmit);

